﻿import { AxiosInstance } from "axios";
import { createLogger } from "logging";

import { DownloadApi } from "./DownloadApi";

const logger = createLogger("ReportApi");

export class ReportApi {
  constructor(
    _axios: AxiosInstance,
    private downloadApi: DownloadApi
  ) {}

  async getRunReport(boardId: string, runId: string, fileName: string): Promise<void> {
    try {
      await this.downloadApi.handleDownload(`/runreadreport/${boardId}/${runId}`, fileName);
    } catch (error) {
      if (error instanceof Error && error.name === "CanceledError") {
        return;
      }
      logger.error("Failed to fetch run report", error);
      throw error;
    }
  }
}
